module.exports = __webpack_public_path__ + "static/img/page1-main.ab619431.jpg";